import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-appdownload',
  templateUrl: './appdownload.component.html',
  styleUrls: ['./appdownload.component.sass']
})
export class AppdownloadComponent implements OnInit {

  constructor(private metaService: MetaService) { }

  ngOnInit() {
    this.metaService.setTitle("Seeguide.at App jetzt kostenlos herunterladen");
    this.metaService.setTags("App, Download, iOS, Apple, kostenlos, App Store, Community, Bewertungen", "Jetzt kostenlos die Seeguide.at App herunterladen und tolle neue Restaurants und Badeplätze rund um den Attersee entdecken.");
  }

}
